import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { SharedModule } from '../../../_shared/shared.module';
import { TaskModule } from '../../task/task.module';
import { NegotiatorLeaderboardRoutingModule } from './negotiator-leaderboard-routing.module';
import { NegotiatorLeaderboardComponent } from './negotiator-leaderboard.component';

@NgModule({
  declarations: [
    NegotiatorLeaderboardComponent,
  ],
  imports:      [
    SharedModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide:    DateAdapter,
      useFactory: adapterFactory,
    }),
    TaskModule,
    NegotiatorLeaderboardRoutingModule,
  ],
})
export class NegotiatorLeaderboardModule {
}